export default __webpack_public_path__ + "static/media/zach_irving.4db030ae.jpg";